/* eslint-disable react/prop-types */
import { Spin, Image, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import Layout from 'Components/Layout';
import { useSelector } from 'react-redux';
import LogoTalentaInsight from 'Components/Logo';
import Menu from 'Components/Menu';
import Navbar from 'Components/Navbar';
import Content from 'Components/Content';
import Footer from 'Components/Footer';
import PanicContent from 'Containers/PanicContent';
import ErrorList from 'Helpers/ErrorList';
import AireneButton from 'Components/AireneButton';
import { 
  CleanupSessionStorage,
  DecodeCurrentUser,
  GetStorage,
  IsMenuEmployee,
  RedirectToManagerDashboard,
  RedirectToSso,
} from 'Helpers';
import { appRoutes } from 'Config/route';
import { CURRENT_USER } from 'Config/constants';
import { StyleWrap } from "./style";

function WrapLayout({
  route,
  component,
  teamManagerToggle,
  ...props
}) {
  const Component = component;
  const currentUserStorage = GetStorage(CURRENT_USER)?.attr;

  const checkAuth = useSelector((state) => state.checkAuth);
  const currentUser = useSelector((state) => state.currentUser);
  const signOut = useSelector((state) => state.signOut);
  // const teamManagerToggle = useSelector((state) => state.teamManagerToggle);

  const isError = checkAuth.status > 404 || currentUser.status > 404 || signOut.status > 404;
  const getStatusAuth = checkAuth.status;
  const getStatusCurrentUser = currentUser.status;
  const isUnauthorized = checkAuth.status === 401 || currentUser.status === 401;
  const isForbidden = checkAuth.status === 403 || currentUser.status === 403;
  const isRequestTimeOut = checkAuth.status === 408 || currentUser.status === 408;
  const isInternalServerError = checkAuth.status === 500 || currentUser.status === 500;
  const isServiceUnavailable = checkAuth.status === 503 || currentUser.status === 503;
  const isGatewayTimeout = checkAuth.status === 504 || currentUser.status === 504;
  const isRenderLoading = !(isError || isUnauthorized || isForbidden || isRequestTimeOut || isInternalServerError || isServiceUnavailable || isGatewayTimeout) && (checkAuth.isLoading || currentUser.isLoading || signOut.isLoading);

  function RenderComponent() {
    if (getStatusAuth in ErrorList || getStatusCurrentUser in ErrorList) {
      if (getStatusAuth === 401 || getStatusCurrentUser === 401) {
        CleanupSessionStorage();
        return RedirectToSso();
      }

      if (getStatusAuth === 403 && teamManagerToggle) {
        const decodedUser = DecodeCurrentUser();
        const jsonUser = JSON.parse(decodedUser);
        const user = jsonUser.current_user;
        if (IsMenuEmployee(user.access_menu)) return RedirectToManagerDashboard();
      }

      return <PanicContent type={getStatusAuth} />
    }

    return <Component {...props} route={route} />
  }

  return (
    <Layout>
      <div className='header-section'>
        <div className='header-logo-container'>
          <div className='header-logo'>
            <Link to={appRoutes.HEADCOUNT_SCREEN}>
              <LogoTalentaInsight />
            </Link>
          </div>
        </div>
        <div className='header-menu-container' span={18} style={{ background: 'white' }}>
          {currentUserStorage && (
            <div className='header-menu'>
              <Menu />
            </div>
          )}
        </div>
        <div className='header-airene-container'>
          <AireneButton />
        </div>
        <div className='header-download-container' style={{ background: 'white' }}>
          {currentUserStorage && (
            <Tooltip title='Export History' placement='left' className='nav-menu'>
              <Link to={appRoutes.EXPORT_HISTORY}>
                <Image src='Download.png' preview={false} />
              </Link>
            </Tooltip>
          )}
        </div>
        <div className='header-navbar-container'>
          <div className='header-navbar'>
            <Navbar />
          </div>
        </div>
      </div>

      <Content>
        {isRenderLoading ? (
          <StyleWrap>
            <div className="loading-content">
              <Spin size="large" />
            </div>
          </StyleWrap>
        ) : <RenderComponent />}

      </Content>
      <Footer />
    </Layout>
  );
}

export default WrapLayout;
